import React, { useEffect, useMemo } from 'react'

import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import { useFirestoreConnect } from 'react-redux-firebase'
import { selectAuth, selectAccountId, selectHash, selectFirestoreData } from '@selectors'
import { SET_ACCOUNT_CONFIG, SET_USER_CONFIG } from '@actions/types'
import Splash from '@components/splash/splash.component'

const FirebaseConfig = ({ children }) => {
  const appIsReady = useSelector(state => state.initialize.appIsReady)
  const auth = useSelector(selectAuth)
  const accountId = useSelector(selectAccountId)
  const hash = useSelector(selectHash)
  const messageLimit = useSelector(state => state.chat.messageLimit)
  const configRef = `config/${accountId}/`
  const emergencyContactsRef = `user-config/${hash}`
  const firestoreData = useSelector(selectFirestoreData)
  const messagesRef = `chats/${hash}/messages`

  const dispatch = useDispatch()

  useFirestoreConnect(configRef)

  useFirestoreConnect(emergencyContactsRef)

  const userConfigRef = firestoreData['user-config'] || null
  const accountConfigRef = firestoreData?.config || null

  const userConfig = useMemo(() => userConfigRef ? userConfigRef[auth.hash] : null, [userConfigRef, auth])
  const accountConfig = useMemo(() => accountConfigRef ? accountConfigRef[auth.accountId] : null, [accountConfigRef, auth])

  useEffect(() => {
    if (accountConfig) {
      dispatch({ type: SET_ACCOUNT_CONFIG, payload: { accountConfig } })
    }
  }, [
    accountConfig,
    appIsReady,
    dispatch
  ])

  const messageQuery = useMemo(() => {
    if (!accountConfig || !messagesRef) return null

    const { event_lookback: eventLookback } = accountConfig
    return {
      collection: messagesRef,
      orderBy: ['createdAt', 'desc'],
      limit: messageLimit,
      where: eventLookback?.enabled && Number.isInteger(eventLookback.total_seconds) ? ['createdAt', '>', dayjs().subtract(eventLookback.total_seconds, 'seconds').toDate()] : undefined
    }
  }, [accountConfig, messagesRef, messageLimit])

  useFirestoreConnect(messageQuery)

  useEffect(() => {
    if (userConfig) {
      dispatch({ type: SET_USER_CONFIG, payload: { userConfig } })
    }
  }, [
    appIsReady,
    dispatch,
    userConfig
  ])

  if (!appIsReady) return <Splash />

  return <React.Fragment>{children}</React.Fragment>
}

export default FirebaseConfig
